import React from "react";
import "./CompanyStory.css";
import companystory from "../../assests/images/CompanyStory.jpeg";

function CompanyStory() {
  return (
    <section className="company-story">
      <div className="container">
        <div className="row align-items-center">
          {/* Left Image */}

          <div
            className="col-lg-6 mb-4 mb-lg-0"
            data-aos="fade-right"
            data-aos-duration="1000"
          >
            <div className="story-image-wrapper">
              <img
                src={companystory}
                alt="MR. MOB FIXER Technician"
                className="img-fluid story-image"
              />
            </div>
          </div>

          {/* Right Content */}

          <div
            className="col-lg-6"
            data-aos="fade-left"
            data-aos-duration="1000"
          >
            <span className="section-badge">Who We Are</span>

            <h2 className="story-title">
              Bringing Mobile Repair Services Directly To You
            </h2>

            <p className="story-text">
              MR. MOB FIXER was founded with a simple goal: to make mobile
              repairs convenient, fast, and stress-free.
            </p>

            <p className="story-text">
              Instead of asking customers to travel to a repair shop, our
              technicians come directly to homes, offices, and preferred
              locations across the UAE.
            </p>

            <p className="story-text">
              From cracked screens and battery replacements to software
              troubleshooting and motherboard repairs, we provide professional
              solutions for both iPhone and Android devices.
            </p>

            <div
              className="story-highlights"
              data-aos="fade-up"
              data-aos-delay="300"
            >
              <div>✓ Certified Technicians</div>
              <div>✓ Genuine Parts</div>
              <div>✓ Same-Day Service</div>
              <div>✓ Customer Satisfaction</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default CompanyStory;
